(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const dry = root.querySelector('#WholesaleDry');
    const wet = root.querySelector('#WholesaleWet');
    function validateFoodMix() {
      if (!dry || !wet) return;
      wet.setCustomValidity(dry.value !== '' && wet.value !== '' && Number(dry.value) + Number(wet.value) !== 100 ? root.dataset.foodMixValidation : '');
    }
    dry?.addEventListener('input', validateFoodMix);
    wet?.addEventListener('input', validateFoodMix);
    const panels = Array.from(root.querySelectorAll('.shw-order-category'));
    const links = Array.from(root.querySelectorAll('.shw-category-nav a'));
    const categoryActions = [...links, ...root.querySelectorAll('[data-next-category]')];
    const search = root.querySelector('[data-catalog-search]');
    const empty = root.querySelector('[data-catalog-empty]');
    let active = panels[0]?.id;
    const cards = Array.from(root.querySelectorAll('.shw-product'));
    function display() {
      const query = (search?.value || '').trim().toLocaleLowerCase();
      let total = 0;
      panels.forEach(panel => {
        let count = 0;
        panel.querySelectorAll('.shw-product').forEach(card => {
          card.hidden = !!query && !card.dataset.search.toLocaleLowerCase().includes(query);
          if (!card.hidden) count++;
        });
        panel.querySelectorAll('.shw-recipe-group').forEach(group => {
          group.hidden = !Array.from(group.querySelectorAll('.shw-product')).some(card => !card.hidden);
        });
        panel.hidden = query ? count === 0 : panel.id !== active;
        if (!panel.hidden) total += count;
      });
      links.forEach(link => link.setAttribute('aria-current', !query && link.hash.slice(1) === active ? 'true' : 'false'));
      if (empty) empty.hidden = total > 0;
    }
    if (panels.length) {
      root.classList.add('shw-enhanced');
      categoryActions.forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        active = link.hash.slice(1);
        if (search) search.value = '';
        display();
        root.querySelector('#' + active)?.scrollIntoView({block: 'start', behavior: 'smooth'});
      }));
      search?.addEventListener('input', display);
      display();
    }
    const forms = Array.from(root.querySelectorAll('.shw-product-form'));
    forms.forEach(form => form.querySelector('select[name="id"]')?.addEventListener('change', event => {
      const option = event.target.selectedOptions[0];
      const card = form.closest('.shw-product');
      card.querySelector('[data-wholesale-price]').textContent = option.dataset.wholesale;
      card.querySelector('[data-retail-price]').textContent = option.dataset.retail;
    }));
    if (!forms.length) return;
    const summary = root.querySelector('[data-order-summary]');
    const eligible = new Set(cards.map(card => Number(card.dataset.productId)));
    const routeRoot = window.Shopify?.routes?.root || '/';
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: root.dataset.currency}).format(cents / 100);
    async function refreshSummary() {
      if (!summary) return;
      try {
        const response = await fetch(`${routeRoot}cart.js`, {headers: {Accept: 'application/json'}});
        if (!response.ok) return;
        const cart = await response.json();
        if (window.bzotech && typeof window.bzotech.doUpdateDropdownCart === 'function') {
          window.bzotech.doUpdateDropdownCart(cart);
        }
        const items = cart.items.filter(item => eligible.has(item.product_id));
        const retail = items.reduce((sum, item) => sum + item.original_line_price, 0);
        summary.querySelector('[data-order-count]').textContent = items.reduce((sum, item) => sum + item.quantity, 0);
        summary.querySelector('[data-order-estimate]').textContent = money(Math.round(retail * 0.6));
        summary.querySelector('[data-order-progress]').value = Math.min(retail, 66667);
        summary.querySelector('[data-order-minimum]').textContent = retail >= 66667 ? root.dataset.minimumMet : root.dataset.minimumRemaining.replace('[amount]', money(Math.max(0, 40000 - Math.round(retail * 0.6))));
        summary.hidden = false;
      } catch (_) { /* Native cart remains available if a network request fails. */ }
    }
    forms.forEach(form => form.addEventListener('submit', async event => {
      if (!form.reportValidity()) return;
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[role="status"]');
      button.disabled = true;
      status.textContent = root.dataset.adding;
      try {
        const response = await fetch(`${routeRoot}cart/add.js`, {method: 'POST', body: new FormData(form), headers: {Accept: 'application/json'}});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || root.dataset.addError);
        status.textContent = root.dataset.added;
        await refreshSummary();
      } catch (error) {
        status.textContent = error.message || root.dataset.addError;
      } finally {
        button.disabled = false;
      }
    }));
    refreshSummary();
  }
  document.querySelectorAll('[data-wholesale-catalog]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wholesale-catalog]').forEach(initialize));
})();
